export default __webpack_public_path__ + "img/9f3a232a44d122feeb85d4f9da7b36fb.jpeg";